<template>
    <!-- 팝업 -->
    <div class="pop_up_layer find_account" style="display: block" @click="closeModal"></div>
    <div class="pop_up pop_detail" id="find_account" style="display: block">
        <button class="close_btn" @click="closeModal">
            <img src="img/close.png" alt="닫기" />
        </button>

        <!-- 
        0: 아이디 찾기
        1: 비밀번호 찾기
        2: 비밀번호 변경
          -->
        <template v-if="state.tab === 0 || state.tab === 1 || state.tab === 2">
            <div class="tab_wrap">
                <button data-btn="find_id" @click="changeTab(0)" :class="[state.tab === 0 ? 'active' : '']">아이디 찾기</button>
                <button data-btn="find_pw" @click="changeTab(1)" :class="[state.tab === 1 || state.tab === 2 ? 'active' : '']">비밀번호 찾기</button>
            </div>
        </template>
        <template v-else>
            <div class="pop_tit">
                <p v-text="state.title"></p>
            </div>
        </template>

        <template v-if="state.tab === 0">
            <div class="content_wrap sign_form" id="find_id" v-if="state.isForm && !state.isResult">
                <ul>
                    <li>
                        <span>이름</span>
                        <input id="name" type="text" v-model="state.name" placeholder="이름을 입력하세요" />
                    </li>
                    <li>
                        <span>전화번호</span>
                        <input id="phone" type="text" v-model="state.phone" placeholder="전화번호를 입력하세요" />
                    </li>
                </ul>
                <div class="btn_wrap _default">
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>

            <div class="content_wrap" v-if="!state.isForm && state.isResult">
                <div class="result_wrap">
                    <p>
                        회원님의 아이디는
                        <br />
                        <em>{{ state.result }}</em>
                        입니다.
                    </p>
                </div>
                <div class="btn_wrap _default">
                    <button class="submit_btn _gray" @click="changeTab(1)">비밀번호 찾기</button>
                    <button class="submit_btn" @click="closeModal">확인</button>
                </div>
            </div>
        </template>

        <template v-else-if="state.tab === 1">
            <div class="content_wrap sign_form" id="find_pw" v-if="state.isForm && !state.isResult">
                <ul>
                    <li>
                        <span>아이디</span>
                        <input id="id" type="text" v-model="state.id" placeholder="아이디를 입력하세요" />
                    </li>
                    <li>
                        <span>이름</span>
                        <input id="name" type="text" v-model="state.name" placeholder="이름을 입력하세요" />
                    </li>
                    <li>
                        <span>전화번호</span>
                        <input id="phone" type="text" v-model="state.phone" placeholder="전화번호를 입력하세요" />
                    </li>
                </ul>
                <div class="btn_wrap _default">
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
            <div class="content_wrap" v-if="!state.isForm && state.isResult">
                <div class="result_wrap">
                    <p>
                        회원가입 시 입력한 이메일로
                        <br />
                        임시 비밀번호를 보냈습니다.
                    </p>
                </div>
                <div class="btn_wrap _default">
                    <button class="submit_btn _gray" @click="changeTab(2)">비밀번호 변경</button>
                    <button class="submit_btn" @click="closeModal">확인</button>
                </div>
            </div>
        </template>
        <template v-else-if="state.tab === 2">
            <div class="content_wrap sign_form">
                <p class="con_tit">비밀번호 변경</p>
                <ul>
                    <li>
                        <input id="oldPw" type="password" v-model="state.oldPw" placeholder="기존 비밀번호를 입력하세요 " />
                    </li>
                    <li>
                        <input
                            id="pw"
                            type="password"
                            v-model="state.newPw"
                            placeholder="새 비밀번호를 입력하세요"
                            @change="
                                (state.isValidateNewPw = validateCheck(state.newPw)),
                                    (state.isValidateNewPw2 = validateCheck(state.newPw2) || state.newPw !== state.newPw2)
                            "
                            @keyup="
                                (state.isValidateNewPw = validateCheck(state.newPw)),
                                    (state.isValidateNewPw2 = validateCheck(state.newPw2) || state.newPw !== state.newPw2)
                            "
                        />
                        <p class="p_info" v-if="state.isValidateNewPw">비밀번호는 문자, 숫자, 특수문자의 조합으로 8자 이상 입력해주세요.</p>
                    </li>
                    <li>
                        <input
                            id="pwRe"
                            type="password"
                            v-model="state.newPw2"
                            placeholder="새 비밀번호를 재입력하세요"
                            @change="state.isValidateNewPw2 = validateCheck(state.newPw2) || state.newPw !== state.newPw2"
                            @keyup="state.isValidateNewPw2 = validateCheck(state.newPw2) || state.newPw !== state.newPw2"
                        />
                        <p class="p_warn" v-if="state.isValidateNewPw2">*비밀번호가 일치하지 않습니다.</p>
                    </li>
                </ul>
                <div class="btn_wrap _default">
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>

        <!-- 
        비밀번호 입력 받는 모달
        -->
        <template v-else-if="state.tab === 3 || state.tab === 9">
            <div class="content_wrap sign_form">
                <div class="result_wrap">
                    <p v-html="state.content"></p>
                </div>
                <ul>
                    <li>
                        <input id="pw" type="password" v-model="state.pw" placeholder="비밀번호를 입력하세요 " v-on:keyup.enter="callbackFun" />
                    </li>
                </ul>
                <div class="btn_wrap">
                    <button class="submit_btn _gray" @click="closeModal">취소</button>
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>

        <!-- 
        비밀번호 입력 받는 모달2
        -->
        <template v-else-if="state.tab === 4">
            <div class="content_wrap sign_form">
                <div class="result_wrap">
                    <p v-html="state.content"></p>
                </div>
                <ul>
                    <li>
                        <input id="pw" type="password" v-model="state.pw" placeholder="비밀번호를 입력하세요 " v-on:keyup.enter="callbackFun" />
                    </li>
                </ul>
                <div class="btn_wrap">
                    <button class="submit_btn _gray" @click="closeModal">취소</button>
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>

        <!-- 
        삭제 컨펌 모달
        -->
        <template v-else-if="state.tab === 5 || state.tab === 10">
            <div class="content_wrap sign_form">
                <div class="result_wrap">
                    <p v-html="state.content"></p>
                </div>

                <div class="btn_wrap">
                    <button class="submit_btn _gray" @click="closeModal">취소</button>
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>

        <!-- 
        신청서 (계기, 동기 작성용) 모달
        -->
        <template v-else-if="state.tab === 6">
            <div class="content_wrap sign_form">
                <ul>
                    <li>
                        <label for="terms_title">개인정보 처리방침</label>
                        <div class="terms_content custom_scroll">
                            <p>서울특별시립 다시함께상담센터는 「개인정보보호법」을 준수하며 개인정보 보호에 최선을 다하고 있습니다.</p>
                            <br />
                            <p>
                                서울특별시립 다시함께상담센터는 시민이 필요로 하는 맞춤형 행정정보를 이메일, 휴대폰 문자(SMS) 등을 이용하여 빠르게
                                전달하고자 최소한의 개인정보를 수집하고 있으며 이를 위하여 ‘개인정보 제공 및 활용에 대한 동의’를 구하고 있습니다.
                            </p>
                            <br />
                            <p>
                                수집된 개인정보는 행사, 이벤트, 생활 정보, 센터 소식, 만족도 조사, 설문조사를 알려드리는 데에만 활용되며 일체 타 업무
                                목적으로는 활용되지 않습니다. 또한, 체계적이고 안전한 개인정보 보호 및 관리를 약속드립니다.
                            </p>
                            <br />
                            <p>① 수집목적 : 행사, 이벤트, 생활 정보, 센터 소식, 만족도 조사, 설문조사, 물품 배송</p>
                            <p>② 수집내용 : 필수항목(ID, 성명, 연락처, 생년월일, 성별, 주소(우편번호), 이메일주소), 선택항목(직업, 가입경로)</p>
                            <p>③ 보유기간 : 회원가입 날짜로부터 2년(단, 개인정보 삭제 요청 시 즉시 삭제)</p>
                            <br />
                            <p>서울특별시립 다시함께상담센터</p>
                        </div>
                    </li>

                    <li class="checkbox_wrap" v-if="state.isPossible">
                        <label for="chk1">
                            <input id="chk1" type="checkbox" v-model="state.isAgree" ref="isAgree" />
                            <em></em>
                            <span>개인정보 동의</span>
                        </label>
                        <br />
                        <span v-if="!state.isAgree" style="color: red">개인정보를 동의해주세요.</span>
                    </li>
                </ul>

                <div class="btn_wrap">
                    <button class="submit_btn _gray" @click="closeModal">취소</button>
                    <button class="submit_btn" @click="callbackFun" v-if="state.isPossible" :disabled="!state.isAgree">저장</button>
                    <button class="submit_btn" @click="closeModal" v-else>닫기</button>
                </div>
            </div>
        </template>

        <!-- 
        callback이 있는 alert용 모달
        -->
        <template v-else-if="state.tab === 7">
            <div class="content_wrap">
                <div class="result_wrap">
                    <p v-html="state.content"></p>
                </div>
                <div class="btn_wrap">
                    <!-- <button class="submit_btn _gray">취소</button> -->
                    <!-- <button class="submit_btn">예시</button> -->
                    <button class="submit_btn" @click="callbackFun">확인</button>
                </div>
            </div>
        </template>

        <!-- 이미지 상세 모달 -->
        <template v-else-if="state.tab === 11">
            <div class="content_wrap">
                <div class="result_wrap img_modal">
                    <img style="max-width: 100%" :src="state.content" alt="" />
                </div>
                <div class="btn_wrap">
                    <button class="submit_btn" @click="closeModal">확인</button>
                </div>
            </div>
        </template>

        <!-- 캠페인/이벤트 개인정보 동의 -->
        <template v-else-if="state.tab === 12">
            <div class="content_wrap">
                <div class="result_wrap img_modal">
                    <img style="max-width: 100%" :src="state.content" alt="" />
                </div>
                <div class="btn_wrap">
                    <button class="submit_btn" @click="closeModal">확인</button>
                </div>
            </div>
        </template>

        <!-- 
        callback이 없는 alert용 모달 ( -1, 8 )
        -->
        <template v-else>
            <div class="content_wrap">
                <div class="result_wrap">
                    <p v-html="state.content"></p>
                </div>
                <div class="btn_wrap">
                    <!-- <button class="submit_btn _gray">취소</button> -->
                    <!-- <button class="submit_btn">예시</button> -->
                    <button class="submit_btn" @click="closeModal">확인</button>
                </div>
            </div>
        </template>
    </div>
    <!-- 팝업 -->
</template>
<script lang="ts" config>
    import { reactive, onMounted, onUnmounted, watch, CommonUtils } from "@/BaseComponent";

    export default {
        props: {
            type: {
                type: Number,
                default: 0,
            },
            isForm: {
                type: Boolean,
                default: false,
            },
            isResult: {
                type: Boolean,
                default: false,
            },
            content: {
                type: String,
                default: "",
            },
            title: {
                type: String,
                default: "",
            },
            textarea1: {
                type: String,
                default: "",
            },
            textarea2: {
                type: String,
                default: "",
            },
            isAgree: {
                type: Boolean,
                default: false,
            },
            isPossible: {
                type: Boolean,
                default: false,
            },
        },
        emits: ["close", "callback"],
        components: {},
        setup(props: any, { emit }: any) {
            const state = reactive({
                tab: -1 as number,
                isForm: false as boolean,
                isResult: false as boolean,

                name: "" as string,
                phone: "" as string,
                id: "" as string,
                result: "" as string,

                oldPw: "" as string,
                newPw: "" as string,
                newPw2: "" as string,

                pw: "" as string,

                isValidateNewPw: false as boolean,
                isValidateNewPw2: false as boolean,

                title: "" as string,
                content: "" as string,

                textarea1: "" as string,
                textarea2: "" as string,
                isAgree: false as boolean,
                isPossible: false as boolean,
            });

            onMounted(() => {
                CommonUtils.allFocusOut();
                state.tab = props.type;
                state.isForm = props.isForm;
                state.isResult = props.isResult;
                state.result = props.content;

                if (state.tab === 2) {
                    state.isValidateNewPw = true;
                    state.isValidateNewPw2 = true;
                }

                if (state.tab < 0 || state.tab > 2) {
                    state.title = props.title;
                    state.content = props.content;
                }

                if (state.tab === 6) {
                    state.textarea1 = props.textarea1;
                    state.textarea2 = props.textarea2;
                    state.isAgree = props.isAgree !== undefined ? props.isAgree : false;
                    state.isPossible = props.isPossible !== undefined ? props.isPossible : false;
                }

                document.body.style.overflow = "hidden";
            });

            onUnmounted(() => {
                document.body.style.overflow = "";
            });

            watch(props, () => {
                state.tab = props.type;
                state.isForm = props.isForm;
                state.isResult = props.isResult;
                state.result = props.content;
                state.title = props.title;
                state.content = props.content;

                if (state.tab === 0 && state.isResult) {
                    state.id = props.content;
                }

                if (state.tab === 2) {
                    state.isValidateNewPw = true;
                    state.isValidateNewPw2 = true;
                }

                if (state.tab === 6) {
                    state.textarea1 = props.textarea1;
                    state.textarea2 = props.textarea2;
                    state.isAgree = props.isAgree !== undefined ? props.isAgree : false;
                    state.isPossible = props.isPossible !== undefined ? props.isPossible : false;
                }
            });

            const changeTab = (tab: number) => {
                state.tab = tab;
                state.isForm = true;
                state.isResult = false;
            };

            const closeModal = () => {
                emit("close");
            };

            const callbackFun = () => {
                switch (state.tab) {
                    // 0: 아이디 찾기
                    // 1: 비밀번호 찾기
                    // 2: 비밀번호 변경
                    case 0:
                        {
                            if (state.name !== "" && state.phone !== "") {
                                const param: any = {};
                                param.action = "findId";
                                param.name = state.name;
                                param.phone = state.phone;
                                emit("callback", param);
                            } else {
                                alert("이름과 전화번호를 입력해주세요.");
                            }
                        }
                        break;
                    case 1:
                        {
                            if (state.id !== "" && state.name !== "" && state.phone !== "") {
                                const param: any = {};
                                param.action = "findPw";
                                param.name = state.name;
                                param.phone = state.phone;
                                param.id = state.id;
                                emit("callback", param);
                            } else {
                                alert("아이디와 이름, 전화번호를 입력해주세요.");
                            }
                        }
                        break;
                    case 2:
                        {
                            if (state.oldPw !== "" && state.newPw !== "" && state.newPw2 !== "") {
                                const param: any = {};
                                param.action = "changePw";
                                param.id = state.id;
                                param.oldPw = state.oldPw;
                                param.newPw = state.newPw;
                                param.newPw2 = state.newPw2;
                                emit("callback", param);
                            } else {
                                alert("아이디와 이름, 전화번호를 입력해주세요.");
                            }
                        }
                        break;
                    case 3:
                        // 비밀번호 전달 ( 게시글 삭제용 )
                        {
                            if (state.pw !== "") {
                                const param: any = {};
                                param.action = "checkPw";
                                param.pw = state.pw;
                                emit("callback", param);
                            } else {
                                emit("callback", {});
                            }
                        }
                        break;
                    case 4:
                        // 비밀번호 전달 ( 댓글 삭제용 )
                        {
                            const param: any = {};
                            param.action = "checkPwForCheck";
                            param.pw = state.pw;
                            emit("callback", param);
                        }
                        break;
                    case 5:
                        // 삭제 컨펌 모달
                        {
                            const param: any = {};
                            param.action = "confirm";
                            emit("callback", param);
                        }
                        break;
                    case 6:
                    case 12:
                        // 신청서 (계기, 동기 작성용) 모달
                        {
                            if (state.isAgree) {
                                const param: any = {};
                                param.action = "applyContent";
                                param.motiApply1 = state.textarea1;
                                param.motiApply2 = state.textarea2;
                                emit("callback", param);
                            }
                        }
                        break;
                    case 7:
                        // callback이 있는 alert용 모달
                        {
                            const param: any = {};
                            param.action = "callback";
                            emit("callback", param);
                        }
                        break;
                    case 8:
                        // callback이 없는 alert용 모달 ( -1, 8 )
                        {
                            const param: any = {};
                            param.action = "back";
                            emit("callback", param);
                        }
                        break;
                    case 9:
                        // 비회원 게시글 삭제용
                        {
                            if (state.pw !== "") {
                                const param: any = {};
                                param.action = "checkPwForConfirmRemove";
                                param.pw = state.pw;
                                emit("callback", param);
                            } else {
                                emit("callback", {});
                            }
                        }
                        break;
                    // 관리자 게시글 삭제 확인 모달
                    case 10:
                        {
                            const param: any = {};
                            param.action = "confirmRemoveForAdmin";
                            emit("callback", param);
                        }
                        break;
                    case 11:
                        {
                            emit("callback");
                        }
                        break;
                    default:
                        {
                        }
                        break;
                }
            };

            const validateCheck = (text: string): boolean => {
                if (!text) {
                    return true;
                } else {
                    if (!CommonUtils.regexForPassword.test(text)) {
                        return true;
                    }
                }

                return false;
            };
            return { state, changeTab, closeModal, callbackFun, validateCheck };
        },
    };
</script>

<style scoped>
    .textarea {
        width: 100%;
    }
</style>
